<cs-icon-button
  class="btn-close"
  iconType="icon"
  icon="fi-x"
  color="secondary"
  size="12"
  (buttonClick)="close()"
></cs-icon-button>
<div class="wrapper">
  <div class="heading">Redeem Code</div>
  <div class="cont">
    <div class="item">
      <cs-input
        label="Enter Bonus Code"
        [(value)]="redeemCode"
        [marginBottom]="'0px'"
        [placeholder]="'XXX-XXX-XXX-XX'"
      ></cs-input>
    </div>

    <cs-button
      label="Redeem"
      size="large"
      [disabled]="!redeemCode"
      [loading]="loading"
      (buttonClick)="redeem()"
    ></cs-button>
  </div>
</div>
